export default function validateEmailAddress(string) {
	// Very basic check
	return /^[\w-+.]+@([\w-]+\.)+[\w-]{2,4}$/.test(string)
}
